import requestGd from "@/utils/requestGaoding";
import request from "../utils/request";
/**
 * 获取当前权益下载剩余数量
 * @param {*} param0
 * @returns {Promise<{right_code: string,is_finite_quantity: boolean, quantity: number, usage: number,left: number }[]>}
 */
export async function getUserRightCount(data) {
  return request({
    method: "post",
    url: "/biz/user-rights/inspect",
    data: data,
    cache: {
      time: 10000,
    },
  });
}
/**
 * 获取下载前信息
 * @param {{
 *  material_id: number;
 *  type?: string|number; // 下载类型 1: 图片原图，2: 图片大图 3：视频 4：平面模板  5:免扣  6: 视频模板
 *  download_type?: string | number; // 下载方式 下载方式 1: 会员身份下载 2: 单购下载
 *  vip_cert_subject_ids?: number[]; // 授权主体id
 * }} param
 * @returns {Promise<PreDownLoadRes & {err: number|string}>}
 */
export async function getPreDownloadInfo({
  material_id,
  download_type,
  type,
  vip_cert_subject_ids,
}) {
  return requestGd({
    method: "post",
    url: `/trade/material/${material_id}/pre-download`,
    data: {
      download_type,
      type,
      vip_cert_subject_ids,
    },
  });
}
/**
 * 获取下载链接
 * https://yapi.gaoding.com/project/1919/interface/api/202042
 * @param {*} param
 * @returns {Promise<{
 *   code: number,
 *   state: string,
 *   url?: string
 *   err?: number
 *   message?: string,
 *   msg?: string,
 *   data?: {
 *    message?: string,
 *    code?: number
 *   }
 * }>}
 */
export async function getDownloadInfo({ material_id, ...data }) {
  return requestGd({
    method: "post",
    url: `/trade/material/${material_id}/download`,
    data: {
      ...data,
      // 模拟异步下载
      fake_download:
        typeof window !== "undefined"
          ? location.search.includes("fake_download")
          : false,
    },
  });
}

/**
 * 获取下载链接( 拍信异步下载使用 )
 * @param {{
 *  material_id: number;
 *  type?: string | number; // 下载类型 1: 图片原图，2: 图片大图 3：视频 4：平面模板  5:免扣  6: 视频模板
 *  download_type?: string | number; // 下载方式 下载方式 1: 会员身份下载 2: 单购下载
 *  filename?: string; // 文件名
 *  system_code?: number;
 *  format?: string; // 格式
 * }} param
 * @returns {Promise<{url: string, state: string}>}
 * @see https://yapi.gaoding.com/project/1717/interface/api/171785
 */
export async function getDownloadUrl(
  { material_id, ...data },
  ignoreMessage = false
) {
  return requestGd({
    method: "post",
    url: `/trade/material/${material_id}/origin-url`,
    data,
    ignoreMessage,
  });
}

/**
 * 检测用户是否有某个素材的下载记录
 * @param {{
 *  material_id: string;
 * }} param
 * @returns {Promise<{ downloaded: boolean } & {err: number|string}>}
 */
export async function getHasDownloaded({ material_id }) {
  return request({
    url: "/users/materials/download_status",
    query: {
      material_id,
    },
  });
}

/**
 * https://yapi.gaoding.com/project/1919/interface/api/202446
 * 检测是否为受限用户
 * @returns {Promise<{
 *  sensitive_limit: boolean;
 *  vcg_limited: boolean;
 *  category_limited: boolean;
 *  personal_category_vip: boolean
 *  material_vip_produced: boolean
 * }}}  sensitive_limited 敏感素材限制用户 vcg_limited 视觉中国限制用户 category_limited 品类受限
 */
export async function checkDownloadLimit(materialId) {
  return requestGd({
    url: "/trade/material/check-download-limit",
    query: {
      id: materialId,
    },
  });
}

/**
 * 素材下载保存到库
 * @param {{
 *  download_ids: number[];
 *  folder_id: number;
 *  repository_id: number;
 * }} param
 * @returns {Promise<{
 *  id: number,
 * }>}
 */
export async function materialDownloadSaveToSpace({
  download_ids,
  folder_id,
  repository_id,
}) {
  return requestGd({
    method: "post",
    url: "/tb-dam/asset/copyright-materials/import",
    data: {
      download_ids,
      folder_id,
      repository_id,
    },
  });
}

/**
 * 获取创作空间ID
 * @returns {Promise<{
 *  id: number,
 *  name: string,
 *  repository_id: number,
 * }[]>}
 */
export async function getMySpaceId() {
  return requestGd({
    url: "/tb-dam/repositories",
    query: {
      types: 1,
    },
  });
}
